import { render, staticRenderFns } from "./HeroNewsSingle.vue?vue&type=template&id=6672efef&"
import script from "./HeroNewsSingle.vue?vue&type=script&lang=js&"
export * from "./HeroNewsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports